import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { AuthService } from "./auth.service";

import { ErrorLogger } from "./error-logger";
import { BusyService } from "./busy.service";
import { DbQueryService } from "./db-query.service";
import { UnitOfWork } from "./unit-of-work";
import { DbSaveService } from "./db-save.service";
import { DialogService } from "primeng/dynamicdialog";
import { DialogWrapperService } from "./dialog-wrapper.service";
import { ToastrService } from "ngx-toastr";
import { NavigationStateService } from "@/layout/service/navigation-state.service";

@Injectable({ providedIn: "root" })
export class DomainService {
  constructor(
    public uow: UnitOfWork,
    public authService: AuthService,
    public dbQueryService: DbQueryService,
    public dbSaveService: DbSaveService,
    public dialogService: DialogWrapperService,
    public pngDialogService: DialogService,
    public toastService: ToastrService,
    public errorLogger: ErrorLogger,
    public busyService: BusyService,
    public router: Router,
    public location: Location,
    public navigationStateService: NavigationStateService
  ) {
    // Note: can't include ActivatedRoute or ElementRef here
  }
}
